import { FC } from 'react';
import styled from 'styled-components';

const StyledLinkText = styled.span<IProps>`
  font-size: 14px;
  line-height: 24px;
  font-weight: 600;
  color: ${({ color, theme }) => (color ? color : theme.vars.newColor.blue2)};

  &:focus,
  &:hover {
    color: ${({ hoverColor, theme }) => (hoverColor ? hoverColor : theme.vars.newColor.blue3)};
    text-decoration: none;
  }
`;

export interface IProps {
  /** Text color. Defaults to theme.vars.newColor.blue2 */
  color?: string;
  /** Text color. Defaults to theme.vars.newColor.blue3 */
  hoverColor?: string;
  /** Optional prop to change the semantic element. Defaults to span. */
  htmlTag?: 'a' | 'span';
}

export const LinkText: FC<IProps> = ({ children, color, hoverColor, htmlTag }) => {
  return (
    <StyledLinkText as={htmlTag} color={color} hoverColor={hoverColor}>
      {children}
    </StyledLinkText>
  );
};

export default LinkText;
